module.exports = __webpack_public_path__ + "img/useravatar.2ca582e6.svg";